export default "__VITE_ASSET__DkJBCgU___"